// Product.js
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  Backdrop,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  Box,
} from "@mui/material";
import { FaEllipsisV, FaEdit } from "react-icons/fa";
import EditProductModal from "../reusable-components/ProductPageComponents/EditProductModal";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import productService from "./../../../services/productService";
import { useSelector } from "react-redux";
import { AiOutlineInfoCircle, AiOutlineSend } from "react-icons/ai";
import SendProductMarketplace from "../../AddProduct/SendProductMarketplace";
import { Edit, Info, Send } from "@mui/icons-material";
import ProductTransferInfoModal from "./ProductPageComponents/ProductTransferInfoModal";
import { RxUpdate } from "react-icons/rx";
import CachedIcon from "@mui/icons-material/Cached";
import StockAndPriceUpdateModal from "../../AddProduct/StockAndPriceUpdateModal";
import { DeleteOutline } from "@mui/icons-material";
import useAlert from "../../../hooks/useAlert";
import { FaStore } from "react-icons/fa";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import ProductPleaceAddModal from "../../AddProduct/ProductPleaceAddModal";
const Product = ({ itemToRender: product, handleSelect, isSelected }) => {
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editedProduct, setEditedProduct] = useState(product);
  const [priceData, setPriceData] = useState([]);
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [openSendModal, setOpenSendModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [openStockEndPriceModal, setOpenStockEndPriceModal] = useState(false);
  const [openProductPleaceModal, setOpenProductPleaceModal] = useState(false);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [loading, setLoading] = useState(false);
  const { showSuccessAlertDeleteProduct, showErrorAlertAll } = useAlert();
  const handleOpenPriceModal = async () => {
    try {
      const result = await productService.getPrice(product.id, token);

      if (result?.data?.length > 0) {
        setPriceData(result.data[0].productPrices);
        setOpenPriceModal(true);
      } else {
        console.error("Fiyat bilgisi bulunamadı.");
        setPriceData([]);
        setOpenPriceModal(true);
      }
    } catch (error) {
      console.error("Ürün fiyatlarını çekerken hata oluştu:", error);
      setPriceData([]);
      setOpenPriceModal(true);
    }
  };

  const handleClosePriceModal = () => setOpenPriceModal(false);
  const handleOpenEditModal = async () => {
    try {
      setLoading(true);
      const result = await productService.getProductDetails(product.id, token);

      if (result) {
        setEditedProduct(result.data[0]);
        setOpenEditModal(true);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Ürün bilgisi bulunamadı.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Ürün bilgilerini çekerken hata oluştu:", error);
    }
  };
  const handleOpenSendModal = async () => {
    setOpenSendModal(true);
  };
  const handleOpenInfoModal = async () => {
    setOpenInfoModal(true);
  };
  const handleOpenStockAndPriceUpdateModal = async () => {
    setOpenStockEndPriceModal(true);
  };
  const handleOpenProductPleaceModal = async () => {
    setOpenProductPleaceModal(true);
  };
  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleCloseSendModal = () => setOpenSendModal(false);
  const handleCloseInfoModal = () => setOpenInfoModal(false);
  const handleCloseStockAndPriceUpdateModal = () =>
    setOpenStockEndPriceModal(false);
  const handleCloseProductPleaceModal = () => setOpenProductPleaceModal(false);

  const imageUrl =
    product.productImages && product.productImages.length > 0
      ? product.productImages[0].imageUrl
      : "https://via.placeholder.com/50";

  const buttonBaseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    padding: "6px",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: "rgb(99, 102, 241)",
    backgroundColor: "white",
    color: "rgb(99, 102, 241)",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    margin: "0 2px",
  };

  const buttonHoverStyle = {
    backgroundColor: "rgb(99, 102, 241)",
    color: "white",
    transform: "translateY(-1px)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };

  const deleteProduct = async () => {
    const isConfirmed = confirm("Bu ürün silinecek, onaylıyor musunuz?");

    if (isConfirmed) {
      try {
        await productService.deleteProduct(product.id);
        showSuccessAlertDeleteProduct();
      } catch (error) {
        showErrorAlertAll();
      }
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <TableRow>
        {/* Etiket - Checkbox */}
        <TableCell>
          <Checkbox
            checked={isSelected || false}
            onChange={handleSelect}
            sx={{
              "&.Mui-checked": { color: "#1F1B45" },
            }}
          />
        </TableCell>

        {/* Ürün Resmi ve Adı */}
        <TableCell>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                position: "relative",
                marginRight: 1,
                "&:hover .product-image-hover": {
                  opacity: 1,
                },
              }}
            >
              <Avatar
                src={imageUrl}
                alt={product.title}
                variant="square"
                style={{ width: 50, height: 50 }}
                title={product.title}
              />
              <Box
                className="product-image-hover"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px",
                  fontSize: "10px",
                  textAlign: "center",
                  opacity: 0,
                  transition: "opacity 0.3s",
                  pointerEvents: "none",
                  wordBreak: "break-word",
                  overflow: "hidden",
                }}
              >
                {product.title}
              </Box>
            </Box>
            <div style={{ flex: 1, minWidth: 0 }}>
              {
                <div
                  style={{
                    fontWeight: "bold",
                    maxWidth: "200px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={product.title}
                >
                  {product.title}
                </div>
              }
              <div
                style={{
                  fontSize: "0.85rem",
                  color: "gray",
                  maxWidth: "250px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={`Stok Kodu: ${product.stockCode}`}
              >
                Stok Kodu: {product.stockCode}
              </div>
            </div>
          </div>
        </TableCell>

        {/* Fiyatı */}
        <TableCell>
          <Button
            variant="outlined"
            sx={{
              color: "#343089",
              borderColor: "#343089",
              textTransform: "none",
              borderRadius: "5px",
              "&:hover": { backgroundColor: "#f1f1f1" },
            }}
            onClick={handleOpenPriceModal}
          >
            Görüntüle
          </Button>
        </TableCell>

        {/* Stok */}
        <TableCell>{product.quantity || 0}</TableCell>
        <TableCell>
          <div
            style={{
              maxWidth: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={product?.category?.name}
          >
            {product?.category?.name || "Kategori Yok"}
          </div>
        </TableCell>

        {/* Platform Yükleme Durumu */}
        <TableCell>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {product?.productPlaces?.map((place, index) =>
              place.marketPlace != null ? (
                <div
                  key={place.id || index}
                  style={{ flex: "1 1 20%", maxWidth: "20%" }}
                >
                  <img
                    src={place.marketPlace?.iconLink}
                    alt="Icon 1"
                    style={{ width: 40, height: 40 }}
                  />
                </div>
              ) : (
                <div
                  key={place.id || index}
                  style={{ flex: "1 1 20%", maxWidth: "20%" }}
                >
                  <img
                    src={place.ecommercePlace?.iconLink}
                    alt="Icon 1"
                    style={{ width: 40, height: 40 }}
                  />
                </div>
              )
            )}
          </div>
        </TableCell>

        {/* Düzenle Butonu */}
        <TableCell>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 80 }}>
            <Select
              value=""
              displayEmpty
              onChange={(e) => {
                const action = e.target.value;
                if (action === "edit") handleOpenEditModal();
                else if (action === "send") handleOpenSendModal();
                else if (action === "info") handleOpenInfoModal();
                else if (action === "updateStockPrice")
                  handleOpenStockAndPriceUpdateModal();
                else if (action === "matchMarketplace")
                  handleOpenProductPleaceModal();
                else if (action === "delete") deleteProduct();

                // Reset select value after action
                e.target.value = "";
              }}
              sx={{
                borderRadius: "8px",
                height: "28px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#6366f1",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#4f46e5",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#4f46e5",
                },
                color: "#6366f1",
                fontSize: "0.75rem",
                padding: 0,
                "& .MuiSelect-select": {
                  padding: "4px 8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                },
              }}
              renderValue={() => <span>•••</span>}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                    borderRadius: "8px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    mt: 0.5,
                  },
                },
              }}
            >
              <MenuItem
                value="edit"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Edit fontSize="small" sx={{ color: "#6366f1" }} />
                <span>Düzenle</span>
              </MenuItem>

              <MenuItem
                value="send"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Send fontSize="small" sx={{ color: "#6366f1" }} />
                <span>Gönder</span>
              </MenuItem>

              <MenuItem
                value="info"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Info fontSize="small" sx={{ color: "#6366f1" }} />
                <span>Ürün Durumu</span>
              </MenuItem>

              <MenuItem
                value="updateStockPrice"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <CachedIcon fontSize="small" sx={{ color: "#6366f1" }} />
                <span>Stok ve Fiyat Güncelle</span>
              </MenuItem>

              <MenuItem
                value="matchMarketplace"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <StorefrontOutlinedIcon
                  fontSize="small"
                  sx={{ color: "#6366f1" }}
                />
                <span>Pazaryeri ile Eşleştir</span>
              </MenuItem>

              <MenuItem
                value="delete"
                sx={{
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "rgb(220, 38, 38)",
                }}
              >
                <DeleteOutline
                  fontSize="small"
                  sx={{ color: "rgb(220, 38, 38)" }}
                />
                <span>Sil</span>
              </MenuItem>
            </Select>
          </FormControl>
        </TableCell>
      </TableRow>

      {/* Fiyat Listesi Modal */}
      <Dialog
        open={openPriceModal}
        onClose={handleClosePriceModal}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: { xs: 2, sm: 4 },
            padding: { xs: 1, sm: 2 },
            backgroundColor: "#f9f9f9",
            width: { xs: "95%", sm: "90%", md: "80%" },
            maxHeight: { xs: "90vh", sm: "80vh" },
            margin: { xs: "10px", sm: "20px" },
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "#333",
            fontSize: { xs: "1.1rem", sm: "1.25rem" },
            padding: { xs: "12px", sm: "16px" },
          }}
        >
          Fiyat Listesi
        </DialogTitle>
        <DialogContent sx={{ padding: { xs: "12px", sm: "16px" } }}>
          {priceData && priceData.length > 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "12px",
                padding: "12px 0",
              }}
            >
              {priceData.map((price, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <h4
                    style={{
                      color:
                        price.ecommercePlace?.colorCode ||
                        price.marketPlace?.colorCode ||
                        "#555",
                      fontWeight: "bold",
                      margin: 0,
                      textAlign: "center",
                      fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
                    }}
                  >
                    {price.ecommercePlace?.name ||
                      price.marketPlace?.name ||
                      "Bilinmeyen"}
                  </h4>
                  <div
                    style={{
                      fontSize: "clamp(0.85rem, 1.8vw, 1rem)",
                      fontWeight: "bold",
                      color: "#555",
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <div>
                      Liste Fiyatı:{" "}
                      {price.listPrice.toLocaleString("tr-TR", {
                        style: "currency",
                        currency: "TRY",
                      })}
                    </div>
                    <div>
                      Satış Fiyatı:{" "}
                      {price.salePrice?.toLocaleString("tr-TR", {
                        style: "currency",
                        currency: "TRY",
                      }) || "Belirtilmemiş"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "gray",
                padding: "20px",
                fontSize: "clamp(0.9rem, 2vw, 1rem)",
              }}
            >
              Fiyat bilgisi bulunamadı.
            </div>
          )}
        </DialogContent>
      </Dialog>
      {openSendModal && (
        <SendProductMarketplace
          open={openSendModal}
          handleClose={handleCloseSendModal}
          productId={product?.id}
          productMainId={product?.productMainId}
        />
      )}
      {/* Düzenleme Modalı */}
      {openEditModal && (
        <EditProductModal
          open={openEditModal}
          handleClose={handleCloseEditModal}
          productData={editedProduct}
          setProduct={setEditedProduct}
          onSave={(updatedProduct) => {
            setEditedProduct(updatedProduct);
            setOpenEditModal(false);
          }}
        />
      )}
      {openInfoModal && (
        <ProductTransferInfoModal
          openInfoModal={openInfoModal}
          handleClose={handleCloseInfoModal}
          productId={product?.id}
        />
      )}
      {openStockEndPriceModal && (
        <StockAndPriceUpdateModal
          open={openStockEndPriceModal}
          onClose={handleCloseStockAndPriceUpdateModal}
          productId={product?.id}
          categoryId={product?.categoryId}
        />
      )}
      {openProductPleaceModal && (
        <ProductPleaceAddModal
          open={openProductPleaceModal}
          onClose={handleCloseProductPleaceModal}
          productId={product?.id}
        />
      )}
    </>
  );
};

export default Product;
